import { httpRequest } from "@/utils/HttpRequest";
import { IKey, IPage, ISearchPage } from "@/types/ScmTypes";
import { ISCMWarehouseSearch, ISCMShelvesBatchInsert, ISCMWarehouseDetail, ISCMWarehouseInsert, ISCMWarehouseUpdate, ISCMAreaSearchFields, ISCMAreaDetail, ISCMAreaInsert, ISCMAreaBatchInsert, ISCMAreaUpdate, ISCMShelvesSearch, ISCMShelvesDetail, ISCMShelvesInsert, ISCMShelvesUpdate, ISCMshelfSearch, ISCMshelfDetail, ISCMshelfInsert, ISCMshelfBatchInsert, ISCMShelfUpdate } from "./warehouseTypes";

export interface IWarehouseFileds {
    shopId?: string | null,                           // null,
    id?: string,                           // "085a638c7e202b1b12aa08f02de5c393",
    shopName?: string | null,                           // null,
    branch?: string,                           // "vrm-sa",
    sourceApp?: string,
    ver?: number,                           // 2,
    enable?: number,                           // 1,
    code?: string,                           // "sa003",
    name?: string,                           // "沙特海外B库",
    orgCode?: string,                           // "组织机构编码",
    orgName?: string,                           // "组织机构名称",
    contact?: string,                           // "test",
    phone?: string,                           // "111111111",
    address?: string,                           // "沙特",
    status?: number,                           // 0,
    note?: string,                           // "1111",
    typeCode?: string,                           // "001",
    typeName?: string,                           // "油品库",
    orderNum?: string | null,                           // null,
    createTime?: string,                           // "2021-01-15 084238",
    createUser?: string,                           // "默认用户",
    updateUser?: string,                           // "默认用户",
    deleteFlag?: number,                           // 0
}
export type IWarehouseSearch = IWarehouseFileds & ISearchPage;
export type IWarehouseDetail = IWarehouseFileds;
// 货位
export interface IShelfFileds {
    id?: string,                  // "1350098495606575105",
    warehouseId?: string,                  // "379fa1bd2cf8af1a8f551b3923ea43b4",
    warehouseName?: string,                  // "沙特库",
    code?: string,                  // "c10",
    note?: string,                  // "",
    status?: number,                  // 0,
    orderNum?: string | null,                  // null,
    createTime?: string,                  // "2021-01-15",
    createUser?: string,                  // "默认用户",
    updateUser?: string | null,                  // null,
    deleteFlag?: number,                  // 0
    warehouseCode?: string
}
export interface IShelfInsert {
    shopId?: string          // "门户id",
    shopName?: string          // "门户名称",
    warehouseId?: string          // "379fa1bd2cf8af1a8f551b3923ea43b4",
    warehouseName?: string          // "沙特库",
    shelvesId?: string          // "",
    shelvesCode?: string          // "",
    areaId?: string          // "",
    areaCode?: string          // "",
    code?: string          // "12212",
    note?: string          // "12212"
}
export type IShelfSearch = IShelfFileds & ISearchPage;

export interface IShelfBatchInsert {
    shopId?: string,         // "门户id",
    shopName?: string,         // "门户名称",
    warehouseId?: string,         // "379fa1bd2cf8af1a8f551b3923ea43b4",
    warehouseName?: string,         // "沙特库",
    shelvesId?: string,         // "",
    shelvesCode?: string,         // "",
    areaId?: string,         // "",
    areaCode?: string,         // "",
    code?: string,         // "",
    note?: string,         // "",
    isBatch?: string,         // "",
    prefix?: string,         // "c",
    startCode?: string,         // "1",
    num?: string | number,         // "10"
}
export interface paramsDisable {
    id: string,
    enable: number
}
class WarehouseService {
    //仓库
    async page(searchVo: IWarehouseSearch) {
        const apiUrl = "/vrm-sa/base/warehouse/findPage";
        return await httpRequest.post<IPage<IWarehouseDetail>>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/base/warehouse/findById/${id}`;
        return await httpRequest.get<ISCMWarehouseDetail>(apiUrl);
    }
    async insert(insertVo: IWarehouseFileds) {
        const apiUrl = "/vrm-sa/base/warehouse/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async update(updateVo: IWarehouseFileds) {
        const apiUrl = "/vrm-sa/base/warehouse/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async disable(params: paramsDisable) {
        const apiUrl = "/vrm-sa/base/warehouse/change";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //货位接口
    async shelfPage(params: IShelfSearch) {
        const apiUrl = "/vrm-sa/base/warehouse/shelf/findPage";
        return await httpRequest.post<IPage<IWarehouseDetail>>(apiUrl, params);
    }
    // async shelfOne(id: string) {
    //     const apiUrl = `/vrm-sa/base/warehouse/findById/${id}`;
    //     return await httpRequest.post<ISCMWarehouseDetail>(apiUrl);
    // }
    async shelfInsert(insertVo: IShelfInsert) {
        const apiUrl = "/vrm-sa/base/warehouse/shelf/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelfBatchInsert(insertVo: IShelfBatchInsert) {
        const apiUrl = "/vrm-sa/base/warehouse/shelf/batchinsert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    async shelfUpdate(updateVo: IShelfFileds) {
        const apiUrl = "/vrm-sa/base/warehouse/shelf/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async shelfImport(updateVo: IShelfFileds) {
        const apiUrl = "/vrm-sa/base/warehouse/shelf/import";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/vrm-sa/base/warehouse/shelf/downloadTpl";
        return await httpRequest.getFile<boolean>(appPageUrl);
    }

    // async areaPage(searchVo: ISCMAreaSearchFields) {
    //     const apiUrl = "/vrm-sa/base/warehouse/area/findPage";
    //     return await httpRequest.post<IPage<ISCMAreaDetail>>(apiUrl, searchVo);
    // }
    // async areaInsert(insertVo: ISCMAreaInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/area/insert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // //批量录入区域
    // async areaBatchInsert(insertVo: ISCMAreaBatchInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/area/batchinsert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // async areaUpdate(updateVo: ISCMAreaUpdate) {
    //     const apiUrl = "/vrm-sa/base/warehouse/area/update";
    //     return await httpRequest.post<boolean>(apiUrl, updateVo);
    // }
    // //区域导入
    // async areaImport(file: { file: File }) {
    //     const appPageUrl = "scm/base/warehouse/area/import";
    //     return await httpRequest.post<boolean>(appPageUrl, file);
    // }
    // //区域模板下载
    // async areaDownloadTpl() {
    //     const appPageUrl = "/vrm-sa/base/material/area/downloadTpl";
    //     return await httpRequest.get<boolean>(appPageUrl);
    // }


    // async shelvesPage(searchVo: ISCMShelvesSearch) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelves/findPage";
    //     return await httpRequest.post<IPage<ISCMShelvesDetail>>(apiUrl, searchVo);
    // }
    // async shelvesInsert(insertVo: ISCMShelvesInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelves/insert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // //批量录入货架
    // async shelvesBatchInsert(insertVo: ISCMShelvesBatchInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelves/batchinsert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // async shelvesUpdate(updateVo: ISCMShelvesUpdate) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelves/update";
    //     return await httpRequest.post<boolean>(apiUrl, updateVo);
    // }
    // //货架导入
    // async shelvesImport(file: { file: File }) {
    //     const appPageUrl = "scm/base/warehouse/shelves/import";
    //     return await httpRequest.post<boolean>(appPageUrl, file);
    // }
    // //货架模板下载
    // async shelvesDownloadTpl() {
    //     const appPageUrl = "/vrm-sa/base/material/shelves/downloadTpl";
    //     return await httpRequest.get<boolean>(appPageUrl);
    // }


    // async shelfPage(searchVo: ISCMshelfSearch) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelf/findPage";
    //     return await httpRequest.post<IPage<ISCMshelfDetail>>(apiUrl, searchVo);
    // }
    // async shelfInsert(insertVo: ISCMshelfInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelf/insert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // //批量新增货位
    // async shelfBatchInsert(insertVo: ISCMshelfBatchInsert) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelf/batchInsert";
    //     return await httpRequest.post<boolean>(apiUrl, insertVo);
    // }
    // async shelfUpdate(updateVo: ISCMShelfUpdate) {
    //     const apiUrl = "/vrm-sa/base/warehouse/shelf/update";
    //     return await httpRequest.post<boolean>(apiUrl, updateVo);
    // }
    // //货位导入
    // async shelfImport(file: { file: File }) {
    //     const appPageUrl = "scm/base/warehouse/shelf/import";
    //     return await httpRequest.post<boolean>(appPageUrl, file);
    // }
    // //货位模板下载
    // async shelfDownloadTpl() {
    //     const appPageUrl = "/vrm-sa/base/material/shelf/downloadTpl";
    //     return await httpRequest.get<boolean>(appPageUrl);
    // }

}

export const warehouseService = new WarehouseService();
